import { forwardRef, useMemo } from 'react';

import {
  BadgeProps as MantineBadgeProps,
  Badge as MantineBadge
} from '@mantine/core';

import { useMergeClassNames } from '../../utils';

import { BadgeOverrideClassNames } from './Badge.styles';

interface BadgeProps extends MantineBadgeProps {
  withBorder?: boolean;
  component?: any;
}

const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  ({ children, withBorder = true, component = 'div', ...rest }, ref) => {
    const classes = useMemo(
      () =>
        BadgeOverrideClassNames({
          withBorder: withBorder,
          ...rest
        }),
      [rest.classNames, withBorder]
    );

    const mergedClasses = useMergeClassNames({
      classNames: [rest.classNames, classes]
    });

    return (
      <MantineBadge
        {...rest}
        component={component}
        classNames={mergedClasses}
        ref={ref}
      >
        {children}
      </MantineBadge>
    );
  }
);

export { Badge };
export type { BadgeProps };
